import axios from 'axios';
import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';

export class PatientAllergiesService {
  constructor() {
    this.apiBase = API_BASE;
  }

  async getAuthHeaders() {
    const token = await getAuthToken();
    if (!token) {
      throw new Error('No authentication token available');
    }
    return { Authorization: `Bearer ${token}` };
  }

  async updatePatientAllergies(patientId, allergies) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await axios.put(`${this.apiBase}/clinical/patients/${patientId}/allergies`, { allergies }, { headers });
      return response.data;
    } catch (error) {
      console.error('Error updating patient allergies:', error);
      throw new Error('Failed to update patient allergies');
    }
  }
}

export default PatientAllergiesService;
